import React, { Component } from 'react'
import ProductInfo from './productInfo.jsx'

class GermanHotelInformation extends Component {
  constructor (props) {
    super(props)

    this.productPagePath = this.productPagePath.bind(this)
    this.pagePath = this.pagePath.bind(this)
    this.mapPagePath = this.mapPagePath.bind(this)
    this.reviewsPagePath = this.reviewsPagePath.bind(this)
    this.videosPagePath = this.videosPagePath.bind(this)
    this.isParkingPage = this.isParkingPage.bind(this)
  }

  pagePath () {
    const path = this.props.pageData.pageName.split('/')
    return '/' + path.slice(0, 2).join('/')
  }

  productPagePath () {
    return this.pagePath() + '.html'
  }

  videosPagePath () {
    return this.pagePath() + '/videos.html'
  }

  mapPagePath () {
    return this.pagePath() + '/anfahrt.html'
  }

  reviewsPagePath () {
    return this.pagePath() + '/kundenbewertungen.html'
  }

  isParkingPage () {
    return this.props.pageData.pageName.match(/.*flughafen-parken.*/)
  }

  isPageExist (path) {
    try {
      const pages = require('../../../../../config/exports/buildTimeOnly/pageListHXDE.json')
      const page = path.replace(/^\/|\.html$/g, '')
      return pages.includes(page)
    } catch (e) {}
    return false
  }

  render () {
    const infoProps = Object.assign({}, this.props)
    delete infoProps.id

    return (
      <div className='tabbable landingtabs' id={this.props.id}>
        <ul className='nav nav-tabs'>
          <li className='active'>
            <a href={this.productPagePath()}>
              {this.isParkingPage()
                ? 'Parkplatz-Informationen'
                : 'Hotel-Informationen'}
            </a>
          </li>
          {this.isPageExist(this.mapPagePath()) && (
            <li>
              <a href={this.mapPagePath()}>Lage &amp; Anfahrt</a>
            </li>
          )}
          {this.isPageExist(this.reviewsPagePath()) && (
            <li>
              <a href={this.reviewsPagePath()}>Kundenbewertungen</a>
            </li>
          )}
          {this.isPageExist(this.videosPagePath()) && (
            <li>
              <a href={this.videosPagePath()}>Videos</a>
            </li>
          )}
        </ul>
        <div className='tab-content'>
          <div className='tab-panel active'>
            {<ProductInfo {...infoProps} />}
          </div>
        </div>
        <a className='pull-right back-to-top' href='#top'>
          nach oben <span className='icon-chevron-sign-up' />
        </a>
      </div>
    )
  }
}

GermanHotelInformation.propTypes = {}

export default GermanHotelInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/germanHotelInformation.jsx